export default __webpack_public_path__ + "static/media/Lighthouse_Dashboard.5b632f31.png";